import React from 'react';
import { Table as AntTable, Spin } from 'antd';

const CMSTable = ({ data, columns, id, loading = false }) => {
    return (
        <div className="mt-3">
            <Spin spinning={loading} size="large">
                <AntTable
                    key={id}
                    columns={columns}
                    dataSource={data}
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                        showTotal: (total) => {
                            return (
                                <span className='color4'>{`Toplam ${total} kayıt`}</span>
                            )
                        }
                    }}
                    scroll={{ x: true }}
                />
            </Spin>
        </div>
    );
};

export default CMSTable;